<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nrUBhr/tc-custom/9781504060677.jpg?1702610651599" alt="This image is the cover for the book Killings"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Killings
      </h1>
      <p class="bookDescription body article font2">
        <b>Two LAPD detectives are at odds over a horrifying case in this “taut shocker” of a novel by an Edgar Award–winning author (<i>The Boston Globe</i>).</b><br/>  <br/> A pair of twins have been brutally murdered, and Los Angeles detectives George Cascade and Ed Fenner find themselves working a case with puzzling sexual overtones. When a young, intellectually disabled African American becomes the object of suspicion, tensions flare between the two officers—and it will push them to the edge before the truth can be sorted out.<br/>  <br/> “The kind of book you read at the point of a switchblade—seemingly faster than you can turn the pages.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Clark Howard
      </h2>
      
      <p class="authorDescription body article">Clark Howard&#160;(1932-2016)&#160;Born in Ripley, Tennessee, Howard&#160;was one of the most honored mystery writers in America and was a longtime favorite of readers of Ellery Queen Mystery Magazine, Alfred Hitchcock Mystery Magazine, and numerous other publications. A professional writer for over 40 years, he wrote sixteen novels, six books of non-fiction, and published two collections of short stories, in addition to more than 200 uncollected short stories. Howard was honored with&#160;the Edgar Allan Poe award for best short story of 1981&#160;from the Mystery Writers of America. In 2009, Howard won the Edward D. Hoch Memorial Golden Derringer Award for Lifetime Achievement from the Short Fiction Mystery Society.&#8203;&#160;&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44fddfb0